import React, {
  Component
} from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import {
  NavHashLink as NavLink
} from "react-router-hash-link";
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import classnames from 'classnames';


const styles = {
  navbar: {
    boxShadow: '0 3px 85px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#d2d2d2',
  }
}

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: false,
    }
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.closeNavbar = this.closeNavbar.bind(this);
  }

  toggleNavbar() {
    this.setState((state, props) => {
      return {
        expanded: !state.expanded
      }
    })
  }

  closeNavbar() {
    this.setState({
      expanded: false
    })
  }

  render() {
    return <Navbar collapseOnSelect expand="lg" fixed="top" variant="light" bg="light" expanded={this.state.expanded} style={styles.navbar}>
          <Container>
            <NavLink smooth to="/#home" className="navbar-brand" onClick={this.closeNavbar}>
              <div className="d-none d-sm-block">
                Limestone City Juggling Festival
              </div>
              <div className="d-block d-sm-none">
                LCJF
              </div>
            </NavLink>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" className="bg-light" onClick={this.toggleNavbar} />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto w-100" onClick={this.closeNavbar}>
                <NavLink smooth to="/#home" className="nav-link d-lg-none">
                  Home
                </NavLink>
                <NavLink smooth to="/#about" className="nav-link ml-lg-auto">
                  About
                </NavLink>
                <NavLink smooth to="/#festivalInfo" className="nav-link">
                  Festival Info
                </NavLink>
                <NavLink to="/GalaShow#top" className="nav-link">
                  Gala Show
                </NavLink>
                <NavLink smooth to="/#faq" className="nav-link">
                  FAQ
                </NavLink>
                <NavLink smooth to="/#sponsors" className="nav-link">
                  Sponsors
                </NavLink>
                <Nav.Link href="https://www.facebook.com/events/341268380124810/">
                  <FontAwesomeIcon icon={faFacebook} size="lg" className="text-primary"/>
                </Nav.Link>
                <Nav.Link  href="https://www.instagram.com/kingstonjugglers/">
                  <FontAwesomeIcon icon={faInstagram} size="lg" className="text-primary"/>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

  }
}

export default Header;
